<script>
import CheckboxField from '@phoenix/mixins/components/form/fields/CheckboxField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [CheckboxField],

  setup(props) {
    return useField(props);
  },

  computed: {
    checkboxClasses() {
      return {
        'sgphx-checkbox sgphx-text-muted': this.isSgphx,
        'sgphx-checkbox--invalid': this.isSgphx && this.isInvalid,
        checkbox: !this.isSgphx,
        'checkbox--invalid': !this.isSgphx && this.isInvalid,
      };
    },
  },
};
</script>

<template>
  <div v-if="isSgphx" :class="checkboxClasses">
    <input
      :id="fieldUniqueId"
      v-model="value"
      :name="field.name"
      :aria-describedby="ariaDescribedby"
      type="checkbox"
      class="sgphx-checkbox__input"
      is-sgphx
    />
    <label :for="fieldUniqueId" class="sgphx-checkbox__label" v-html="field.label" />
  </div>

  <div v-else :class="checkboxClasses">
    <input
      :id="fieldUniqueId"
      v-model="value"
      :name="field.name"
      :aria-describedby="ariaDescribedby"
      type="checkbox"
      class="checkbox__input"
    />
    <label :for="fieldUniqueId" class="checkbox__label" v-html="field.label" />
  </div>
</template>
